/**
 * Created by Owner on 2016/8/6.
 * 胆拖
 */
import {Component} from '@angular/core';
import {LotteryMathZXFSComponent} from "./zxfs";
import {LotteryMath} from "./lotteryMath";
import {MathUtil} from "../../util/mathUtil";

@Component({
  selector: 'lottery-math-dt',
  templateUrl: 'selectMath.html',
})
export class LotteryMathDTComponent extends LotteryMathZXFSComponent implements LotteryMath {
  ngOnInit() {
  }

  changeTotal(selectInfo: any) {
    let mname = this.selectAreaOption["mname"];
    let tmpTotal: number = 1;
    let place = selectInfo.selectOption.place == 0 ? 1 : 0;
    let data_sel = this.children.toArray();
    data_sel[place].deleteNo(selectInfo.selectNo);
    var danlen = data_sel[0].selectNo.length;
    var tuolen = data_sel[1].selectNo.length;
    var sellen = parseInt(mname.charAt(mname.length - 1));
    if (danlen < 1 || tuolen < 1 || danlen >= sellen) {
      tmpTotal = 0
    } else {
      tmpTotal = MathUtil.combination(tuolen, sellen - danlen);
    }
    this.setTotal(tmpTotal);
  }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/dt.ts